"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiHelp = function IconUiHelp(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M29.9 10.465a8.272 8.272 0 0 0-11.735 0 8.051 8.051 0 0 0-2.265 4.118l-.161.783 1.566.322.161-.783a6.769 6.769 0 0 1 6.591-5.282 6.377 6.377 0 0 1 4.711 1.977 6.4 6.4 0 0 1 1.832 3.312 6.688 6.688 0 0 1 .144 1.393 6.377 6.377 0 0 1-1.973 4.71l-.271.275q-.33.276-.61.553l-2.225 1.748a6.174 6.174 0 0 0-2.4 3.994c-.038.384-.057.773-.057 1.155v2.414h1.6V28.74c0-.332.017-.665.044-.952a4.543 4.543 0 0 1 1.8-2.941l2.26-1.777.072-.063c.163-.163.343-.327.592-.538l.323-.324a8 8 0 0 0 2.441-5.84 8.231 8.231 0 0 0-.178-1.722 8.044 8.044 0 0 0-2.262-4.118z"
  }), _react.default.createElement("circle", {
    cx: 24.004,
    cy: 38.026,
    r: 1.998
  }));
};

IconUiHelp.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiHelp;
exports.default = _default;